export default {
  namespaced: true,
  state: {
    darken: false,
  },
  getters: {},
  actions: {
    setDarken({ commit }, payload) {
      if (payload !== null) {
        commit('SET_DARKEN', payload);
      } else {
        commit('TOGGLE_DARKEN');
      }
    },
  },
  mutations: {
    SET_DARKEN(state, payload) {
      state.darken = payload;
    },
    TOGGLE_DARKEN(state) {
      state.darken = !state.darken;
    },
  },
};
